<template>
  <div>
    <!-- <transition name="fade"> -->

    <svg v-show="icon == 'sb'" class="main-icon" viewBox="0 0 40.04 21.52">
      <path
        d="M40,3a3,3,0,1,0-4.71,2.46,15.5,15.5,0,0,1-30.62,0,3,3,0,1,0-3,.24,18.49,18.49,0,0,0,36.6,0A3,3,0,0,0,40,3Z"
      />
    </svg>

    <!-- </transition> -->

    <div
      v-show="icon == 'magnifier'"
      style="
        -webkit-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        transform: rotate(90deg);
        font-size: 24px;
      "
    >
      <svg
        x="0px"
        y="0px"
        viewBox="0 0 512.005 512.005"
        style="enable-background: new 0 0 512.005 512.005"
        xml:space="preserve"
      >
        <path
          d="M505.749,475.587l-145.6-145.6c28.203-34.837,45.184-79.104,45.184-127.317c0-111.744-90.923-202.667-202.667-202.667
			S0,90.925,0,202.669s90.923,202.667,202.667,202.667c48.213,0,92.48-16.981,127.317-45.184l145.6,145.6
			c4.16,4.16,9.621,6.251,15.083,6.251s10.923-2.091,15.083-6.251C514.091,497.411,514.091,483.928,505.749,475.587z
			 M202.667,362.669c-88.235,0-160-71.765-160-160s71.765-160,160-160s160,71.765,160,160S290.901,362.669,202.667,362.669z"
        />
      </svg>

      <!-- &#9906; -->
    </div>
    <!-- <transition name="fade-rotate"> -->
    <svg
      focusable="false"
      viewBox="0 0 16 14"
      width="28"
      height="25"
      style="max-width: 18px; max-height: 18px"
      xmlns="http://www.w3.org/2000/svg"
      v-if="icon == 'arrow'"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M.116 4.884l1.768-1.768L8 9.232l6.116-6.116 1.768 1.768L8 12.768.116 4.884z"
      ></path>
    </svg>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "sb",
    },
  },
};
</script>

<style scoped>
div {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--shopbox-text-light);
}
.main-icon {
  margin-bottom: 10px !important;
  display: block;
}
svg {
  width: 54%;
  height: 54%;
  fill: var(--shopbox-text-light);
}

.fade-leave-active,
.fade-enter-active {
  transition: opacity 150ms ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  position: absolute;
  transition: opacity 150ms ease-out;
}

.fade-rotate-enter-active,
.fade-rotate-leave-active {
  transition: transform 0.16s ease-out, opacity 100ms ease-out;
}

.fade-rotate-enter,
.fade-rotate-leave-to {
  opacity: 0;
  transform: rotate(-30deg);
  transform-origin: center center;
  position: absolute;
}
</style>
